export default __webpack_public_path__ + "static/Vol 3 - TA 1A - LVA (with appendices) compressed-e7890d94b5fe67692fd028759a981fd8.pdf";